import { BehaviorSubject } from 'rxjs';
import jwt from 'jwt-decode';

const CURRENT_USER = 'currentUser';

const currentUserSubject = new BehaviorSubject(JSON.parse(sessionStorage.getItem(CURRENT_USER)));
//const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem(CURRENT_USER)));

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return  currentUserSubject.value }
}

async function login(userName, password) {
    const loginData = {
        userName: userName,
        password: password
    };
    const requestParams = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData)
    };

    const request = new Request('/api/authentication/token', requestParams);
    let response = await fetch(request);

    const data = await response.json();

    if (!response.ok) {
        if ([401, 403].indexOf(response.status) != -1) {
            logout();
            //location.reload(true);
        }

        const error = (data && data.message) || response.statusText;
        throw new Error(error);
    }

    let user = {
        token: data.token,
        userName: data.userName,
        claims: jwt(data.token)
    }
    sessionStorage.setItem(CURRENT_USER, JSON.stringify(user));
    //localStorage.setItem(CURRENT_USER, JSON.stringify(user));
    currentUserSubject.next(data);
}


function logout() {
    //localStorage.removeItem(CURRENT_USER);
    sessionStorage.removeItem(CURRENT_USER);
    currentUserSubject.next(null);
}